import { render, staticRenderFns } from "./distributionUsers.vue?vue&type=template&id=2fe36e1e&scoped=true&"
import script from "./distributionUsers.vue?vue&type=script&lang=js&"
export * from "./distributionUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe36e1e",
  null
  
)

export default component.exports